import { createContext, PropsWithChildren, useCallback, useContext, useMemo, useState } from "react";

import { BlockingProgress } from "./BlockingProgress";

const Context = createContext<{
    block: () => void;
    flashMessage: (item: JSX.Element) => Promise<void>;
    unblock: () => void;
}>(undefined as any);

export const BlockingProgressProvider = (props: PropsWithChildren<{}>) => {
    const [state, setState] = useState<{ blocking: boolean, item: JSX.Element | null, callback?: () => void }>({
        blocking: false,
        item: null,
    });

    const block = useCallback(() => {
        setState({ blocking: true, item: null });
    }, []);

    const flashMessage = useCallback((item: JSX.Element) => {
        return new Promise<void>((resolve) => {
            setState({ blocking: true, item: item, callback: resolve as () => void });
        });
    }, []);

    const unblock = useCallback(() => {
        setState({ blocking: false, item: null });
    }, []);

    const value = useMemo(() => ({ block, flashMessage, unblock }), [block, flashMessage, unblock]);

    return (
        <Context.Provider value={value}>

            {props.children}
            <BlockingProgress open={state.blocking} item={state.item} callback={state.callback} />

        </Context.Provider>
    );
};

export const useBlockingProgress = () => {
    return useContext(Context);
}
